<span class="flex-1">{{ title }}</span>
<mat-slide-toggle
  [disabled]="isToggleDisabled"
  *ngIf="hasToggle"
  [checked]="!isHideContent"
  (change)="!$event.checked ? hideContent.emit(false) : null"
></mat-slide-toggle>
<mw-arrow-toggler
  *ngIf="foldable"
  [state]="isHideContent ? 'collapsed' : 'expanded'"
  (toggle)="hideContent.emit($event === 'collapsed')"
></mw-arrow-toggler>
